import { additionalFieldsData } from "../../variables/additional-fields-data";

export const validatePhoneNumber = (phoneNumber) => {
  const res = additionalFieldsData.phone.regexp;
  return res.test(phoneNumber);
};
